import db from "../db/database";
import { markForDelete, markForSync } from "./syncService";

// Servicio para manejar las operaciones relacionadas con los clientes

// Agregar un nuevo cliente a la base de datos
export const addClient = async (client) => {
	try {
		// Verificar si el nombre del cliente ya existe
		const existingClient = await db.clients
			.where("name")
			.equals(client.name)
			.first();

		if (existingClient) {
			throw new Error("Ya existe un cliente con ese nombre");
		}

		// Agregar el cliente a la base de datos
		const id = await db.clients.add({
			name: client.name,
			Direccion: client.Direccion || "",
			Direccion_2: client.Direccion_2 || "",
			Poblacion: client.Poblacion || "",
			Cod_Postal: client.Cod_Postal || "",
			Pais: client.Pais || "",
			Telefono: client.Telefono || "",
			Mobil: client.Mobil || "",
			E_Mail: client.E_Mail || "",
			Customer_Price_Group: client.Customer_Price_Group || "",
			Contacto: client.Contacto || "",
			Tipo_Documento_SrI: client.Tipo_Documento_SrI || "Cedula", // Nuevo campo
			Numero_Identificacion_fiscal: client.Numero_Identificacion_fiscal || "",
			POS_Discount: client.POS_Discount || 0,
			createdAt: new Date(),
			pendingSync: 1, // Marcar como pendiente de sincronización (usando 1 en lugar de true)
			lastModified: new Date(),
			No: client.No || null, // Guardar el No de Business Central si existe
			deleted: false,
		});

		return { id, ...client };
	} catch (error) {
		console.error("Error al agregar cliente:", error);
		throw error;
	}
};

// Obtener todos los clientes
export const getAllClients = async () => {
	try {
		// Obtener solo clientes no marcados como eliminados
		const clients = await db.clients
			.filter((client) => !client.deleted)
			.toArray();
		return clients;
	} catch (error) {
		console.error("Error al obtener clientes:", error);
		throw error;
	}
};

// Obtener un cliente por ID local
export const getClientById = async (id) => {
	try {
		const client = await db.clients.get(id);
		if (!client || client.deleted) {
			throw new Error("Cliente no encontrado");
		}
		return client;
	} catch (error) {
		console.error(`Error al obtener cliente con ID ${id}:`, error);
		throw error;
	}
};

// Obtener un cliente por No de Business Central
export const getClientByNo = async (no) => {
	try {
		const client = await db.clients
			.where("No")
			.equals(no)
			.and((client) => !client.deleted)
			.first();

		if (!client) {
			throw new Error("Cliente no encontrado");
		}
		return client;
	} catch (error) {
		console.error(`Error al obtener cliente con No ${no}:`, error);
		throw error;
	}
};

export const getClientByNoOrId = async (no) => {
	try {
		let client = await db.clients.get(no);
		if (!client) {
			client = await db.clients
				.where("No")
				.equals(no)
				.and((client) => !client.deleted)
				.first();
		}
		return client;
	} catch (error) {
	}
};
// Actualizar un cliente existente
export const updateClient = async (id, clientData) => {
	try {
		const client = await db.clients.get(id);
		if (!client || client.deleted) {
			throw new Error("Cliente no encontrado");
		}

		// Actualizar el cliente
		await db.clients.update(id, {
			...clientData,
			lastModified: new Date(),
		});

		// Marcar como pendiente de sincronización
		await markForSync("clients", id);

		return await getClientById(id);
	} catch (error) {
		console.error(`Error al actualizar cliente con ID ${id}:`, error);
		throw error;
	}
};

// Eliminar un cliente
export const deleteClient = async (id) => {
	try {
		const client = await db.clients.get(id);
		if (!client) {
			throw new Error("Cliente no encontrado");
		}

		// Marcar como eliminado y pendiente de sincronización
		await markForDelete("clients", id);

		return true;
	} catch (error) {
		console.error(`Error al eliminar cliente con ID ${id}:`, error);
		throw error;
	}
};
